const baseColors = {
  main: ['#FFFFFF', '#007BFF', '#2B2F3B', '#F70844', '#EA5D5D', '#727888'],
  second: ['#D9DADE', '#F0F0EF', '#F2F2F0', '#F1FEFA', '#042F21'],
  supplementary: [
    '#FF806E',
    '#FFA617',
    '#00DD83',
    '#B061F7',
    '#00D1DB',
    '#ED0164',
    '#C4C4C4',
  ],
  dark: ['#540021', '#492300', '#00443F', '#4F055E', '#2B2F3B', '#5C0020'],
};
export default baseColors;
